const Info = {
    API_URL : 'https://server.bayatiexchange.com/api/v1/',
    APP_URL : 'https://server.bayatiexchange.com/',
    UPLOADS_URL : 'https://admin.bayatiexchange.com',
    REST_API:'https://',
    GR_KEY : "6LfgZtoUAAAAAJoP3N0YKhnr2g3Q94Ly5G-Ba-NM",
    PHONE : '(+98)2155697816',
    EMAIL : 'info@b-ex.ir',
    FAX : '(+98)2155690135',
    MOBILE : '',
    ADDRESS : 'تهران - سبزه‌میدان - پاساژ خازن‌الملک - پلاک1/6'
}

export default Info